var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99997 3.77778C5.75553 3.77778 5.54627 3.69074 5.3722 3.51667C5.19812 3.34259 5.11108 3.13333 5.11108 2.88889C5.11108 2.64444 5.19812 2.43519 5.3722 2.26111C5.54627 2.08704 5.75553 2 5.99997 2C6.24442 2 6.45368 2.08704 6.62775 2.26111C6.80182 2.43519 6.88886 2.64444 6.88886 2.88889C6.88886 3.13333 6.80182 3.34259 6.62775 3.51667C6.45368 3.69074 6.24442 3.77778 5.99997 3.77778ZM5.99997 10C5.81479 10 5.65738 9.93519 5.52775 9.80556C5.39812 9.67593 5.33331 9.51852 5.33331 9.33333V5.33333C5.33331 5.14815 5.39812 4.99074 5.52775 4.86111C5.65738 4.73148 5.81479 4.66667 5.99997 4.66667C6.18516 4.66667 6.34257 4.73148 6.4722 4.86111C6.60182 4.99074 6.66664 5.14815 6.66664 5.33333V9.33333C6.66664 9.51852 6.60182 9.67593 6.4722 9.80556C6.34257 9.93519 6.18516 10 5.99997 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWhite);
export default __webpack_public_path__ + "static/media/Info_white.f9f54596958bc274fe5fd90e2c66d219.svg";
export { ForwardRef as ReactComponent };